import { Link } from "react-router-dom";
import { ExternalLink, Clock, Map, BookMarked, Headphones, HelpCircle, Library } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { useSettings } from "@/lib/SettingsContext";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/Editorial";

const FEATURES = [
  { Icon: BookMarked, t: "Histoires", d: "Des récits documentés au fil du temps." },
  { Icon: Clock, t: "Voyage dans le temps", d: "Une frise pour situer les époques." },
  { Icon: Map, t: "Carte", d: "Explorer les lieux de l'étrange." },
  { Icon: HelpCircle, t: "Vrai ou légende ?", d: "Distinguer le fait, la croyance et le récit." },
  { Icon: Headphones, t: "Livre du soir & lecture audio", d: "Écouter les histoires racontées." },
  { Icon: Library, t: "Bibliothèque personnelle", d: "Garder ses histoires favorites." },
];

export default function Chroniques() {
  const settings = useSettings();
const url = "https://mystique-chronicles.emergent.host/"
  

  useSeo({
    title: "Les Chroniques de l'Étrange",
    description: "Une exploration documentée de l'histoire de la spiritualité, du mysticisme, de l'occultisme, des arts divinatoires et des grandes légendes.",
    path: "/les-chroniques-de-letrange",
    keywords: ["Les Chroniques de l'Étrange", "histoire de l'ésotérisme", "histoire de la spiritualité", "occultisme", "arts divinatoires", "légendes", "mysticisme", "phénomènes étranges", "vrai ou légende"],
  });

  return (
    <div>
      <PageHeader
        eyebrow="Projet"
        title="Les Chroniques de l'Étrange"
        intro="Une exploration documentée de l'histoire de la spiritualité, du mysticisme, de l'occultisme, des arts divinatoires et des grandes légendes."
        image={IMG.gothic}
        tall
      />

      <section className="dl-container py-16">
        <p className="serif italic text-2xl md:text-3xl text-[#D4B978] leading-snug max-w-3xl">
          « Ici, on distingue toujours ce que l'on sait, ce que l'on croit et ce que l'on raconte. »
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {FEATURES.map(({ Icon, t, d }, i) => (
            <div key={i} className="dl-card p-8">
              <Icon size={22} className="text-[#C6A76A] mb-4" />
              <h3 className="serif text-2xl text-[#F3E9D2]">{t}</h3>
              <p className="text-sm text-[#F3E9D2]/65 mt-2">{d}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a href={url} target="_blank" rel="noreferrer" data-testid="chroniques-external-btn" className="dl-btn dl-btn-solid text-base" style={{ padding: "1.1rem 2.5rem" }}>
            Découvrir les Chroniques de l'Étrange <ExternalLink size={16} />
          </a>
          <p className="text-sm text-[#F3E9D2]/45 mt-4">{url.replace("https://", "")}</p>
        </div>
      </section>

      <section className="relative dl-noise overflow-hidden border-t border-[rgba(198,167,106,0.15)]">
        <div className="absolute inset-0">
          <img src={IMG.highlands} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-[#050814]/80" />
        </div>
        <div className="dl-container relative z-10 py-20 text-center">
          <p className="serif text-3xl md:text-4xl text-[#F3E9D2] max-w-3xl mx-auto leading-tight">
            L'histoire de l'invisible, racontée avec rigueur et curiosité.
          </p>
          <Link to="/histoire-esoterisme" className="dl-btn mt-8">Histoire & Ésotérisme</Link>
        </div>
      </section>
    </div>
  );
}
